"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPartBy = void 0;
exports.getPartBy = function (isChinese, pcs) {
    return pcs[isChinese ? pcs.length - 1 : 0];
};
